import { Component, input, output } from '@angular/core';

import { FontIconComponent } from '@camelot/icons';
import { Address, Contact, formatAddress } from '@camelot/services';
import { TranslatePipe } from '@camelot/translation';
import { ItemProfileDisplayComponent, LinkComponent } from '@camelot/ui';
import { CamBaseComponent, fullName } from '@camelot/utils';

import { CamTranslationCore } from '../../../translation.service';

@Component({
  selector: 'cam-contact-profile',
  imports: [FontIconComponent, ItemProfileDisplayComponent, LinkComponent, TranslatePipe],
  templateUrl: './contact-profile.component.html',
})
export class ContactProfileComponent extends CamBaseComponent {
  contact = input.required<Partial<Contact>>();

  invoicingAddress = input<Address | null>(null);

  withInvoicingAddress = input(false);

  editable = input(false);

  edit = output<void>();

  public readonly fullName = fullName;
  public readonly formatAddress = formatAddress;

  constructor() {
    super();
    CamTranslationCore.getInstance();
  }
}
